import * as React from 'react';
import * as cost from './style.module.scss';
import { TaxDeduction } from "../../../../../TaxDeduction";
export const CostBuyNow = ({ widget }) => {
  return (
    <section className={cost.cost} id="cost">
      <div className="container">
        <div className={cost.cost__block}>
          <div className={cost.cost__info}>
            <h3 className={cost.cost__price}>
              Стоимость обучения
            </h3>
            <p className={cost.cost__rassrocka}>
              Рассрочка на 10 месяцев
            </p>
            <p className={cost.cost__cena}><span className={cost.cost__bigNum}>2 890 </span> ₽/мес </p>
            <p className={cost.cost__description}>
              На курсе мы научим вас запоминать любую информацию быстро, качественно и надолго! Помните, что кто владеет
              информацией, тот владеет миром.
            </p>
            <p className={cost.cost__coursePrice}>
              Стоимость курса – 28 900 ₽
            </p>
            <ul>
              <li className={cost.cost__item}>
                <p>20 видеоуроков с домашним заданием и тестированием;</p>
              </li>
              <li className={cost.cost__item}>
                <p>Бессрочный доступ;</p>
              </li>
              <li className={cost.cost__item}>
                <p>Поддержка куратора и преподавателя;</p>
              </li>
              <li className={cost.cost__item}>
                <p>Общий чат учеников.</p>
              </li>
            </ul>
            <div className={cost.cost__coursePrice}>
              <TaxDeduction margin={"30px 0"}/>
            </div>
          </div>
          <div className={cost.cost__form}>
            { widget }
          </div>
        </div>
      </div>
    </section>
  );
};
